<mat-card class="daxa-card error-card mb-25 pt-0 border-radius bg-white border-none d-block text-center">
    <mat-card-content>
        <img src="images/error.png" alt="error-image">
        <h3>
            OOPS! 404 Nismo pronašli zadanu stranicu!
        </h3>
        <p>
            Ali bez brige! Naš tim traži svugdje dok vi čekate na sigurnom.
        </p>
        <a mat-button routerLink="/">
            Vrati me kući
        </a>
    </mat-card-content>
</mat-card>